import React from 'react'
import Popup from '../Component/Popup'
import HomeSlider from '../Component/HomeSlider'
import TopperXII from '../Component/TopperXII'
import TopperX from '../Component/TopperX'
import Events from '../Component/Events'
import News from '../Component/News'
import Calender from '../Component/Calender'
import Campuscare from '../Component/Campuscare'
import OnlineRegistration from '../Component/OnlineRegistration'
import Gallery from '../Component/Gallery'
import Message from '../Component/Message'
import { Link } from 'react-router-dom'
import Header from '../Component/Header';
import LazyLoad from 'react-lazyload'
import Footer from '../Component/Footer'
const Home = () => {
  return (
    <>
      <Header />
      {/* <Campuscare /> */}
      <Popup />
      {/* <OnlineRegistration /> */}
      <HomeSlider />
      {/* <div className="aboutmidsec padded-sec">
        <div className='button'>
          <Link to="">
            <p>Admission</p>
          </Link>
        </div>
        <div className='button'>
          <Link to="">
            <p>Fee payment</p>
          </Link>
        </div>
        <div className='button'>
          <Link to="">
            <p>alumnae registration</p></Link>
        </div>
        <div className='phone'>
          <a href="tel:01282-260211">
            <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/phone.gif" alt="Mata Mariyam Jan Sewa" /></LazyLoad>
          </a>
        </div>
        <div className='button'>
          <Link to="">
            <p>Results</p>
          </Link>
        </div>
        <div className='button'>
          <Link to="https://portalguidelines.campuscare.info/index.html#MMJSVN" target='_blank'>
            <p> Portal (Help?)</p>
          </Link>
        </div>
        <div className='button'>
          <Link to="https://entab.online/MMJSVN" target="_blank">
            <p>ERP Login</p>
          </Link>
        </div>
      </div> */}
      {/* <div className="aboutsec">
        <div className='circle-block'>
          <div className='circles cir1'></div>
          <div className='circles cir2'></div>
          <div className='circles cir3'></div>
          <div className='circles cir4'></div>
          <div className='circles cir5'></div>
          <div className='circles cir6'></div>
          <div className='circles cir7'></div>
          <div className='circles cir8'></div>
          <div className='circles cir9'></div>
          <div className='circles cir10'></div>
          <div className='circles cir11'></div>
          <div className='circles cir12'></div>
          <div className='circles cir13'></div>
          <div className='circles cir14'></div>
          <div className='circles cir15'></div>
        </div>
        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/about-img.png" className='img-fluid' alt="Mata Mariyam Jan Sewa" />
        <div className='content'>
          <h2 className='mb-4'>Mata Mariam Jan Seva<span className='d-block'> Vidyalaya</span></h2>

          <p>Mata Mariam Jan Seva Vidyalaya was established by Delhi Catholic Archdiocese at Narnaul in April 1992 and is managed by the Society of Pilar, Goa, to impart education to children of all communities with special emphasis on character building, national integration, inculcation of patriotic spirit and secular outlook. The Society of Pilar, a Christian and religious organization is engaged in education, social and religious activities in seventeen states and three union territories of our country. The Sisters of Our Lady of Graces, Meerut (U.P.) an educational and social institutions, joined the management of Mata Mariam Jan Seva Vidyalaya in 1994. Admission is open to all boys and girls irrespective of caste and religion. The children will be trained to acquire self-reliance and become men and women commited to God and the country. The staﬀ will spare no eﬀorts to provide every facility to develop their individual talents.</p>
        </div>
        <a href='/about'>
          <button><span><i className="bi bi-arrow-right"></i></span> Read More</button>
        </a>
      </div> */}
      <section class="about-home">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6 mb-4 mb-lg-0">
              <h2 class="py-3">Mata Mariam Jan Seva<span class="d-block text-dark">Vidyalaya</span></h2>
              <p class="lead">
                Mata Mariam Jan Seva Vidyalaya was established by Delhi Catholic Archdiocese at Narnaul in April 1992 and is managed by the Society of Pilar, Goa, to impart education to children of all communities with special emphasis on character building, national integration, inculcation of patriotic spirit and secular outlook. The Society of Pilar, a Christian and religious organization is engaged in education, social and religious activities in seventeen states and three union territories of our country. The Sisters of Our Lady of Graces, Meerut (U.P.) an educational and social institution, joined the management of Mata Mariam Jan Seva Vidyalaya in 1994. Admission is open to all boys and girls irrespective of caste and religion. The children will be trained to acquire self-reliance and become men and women committed to God and the country. The staff will spare no effort to provide every facility to develop their individual talents.
              </p>
              <a href="/about" class="btn btn-primary">
                Read More <span><i class="bi bi-arrow-right"></i></span>
              </a>
            </div>
            <div class="col-lg-6">
              <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/about.jpg" class="img-fluid rounded shadow-lg mx-auto d-block" alt="Mata Mariyam Jan Sewa" />
            </div>
          </div>
        </div>
      </section>
      <div className="event">
        <div className="container-fluid fulwidth">
          <div className="row">
            <div className="col-lg-5 section-title">
              <div className='title'>
                <p>Message section</p>
                <h2>From the desk of</h2>
              </div>
              <Message />
            </div>
            <div className="col-lg-7">
              <div className="news_section">
                <div className='title'>
                  <p>Notice board</p>
                  <h2>Latest News & Announcement</h2>
                </div>
                <News />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="schoolInsight">
        <div className="container">
          <div className="row">
            <div className='title mb-4'>
              <p>school insights</p>
              <h2>Growing at Mata Mariam</h2>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 p-0">
              <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/senior-activity.png" className="img-fluid" alt="Mata Mariyam Jan Sewa" />
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 p-0">
              <div className="insights-content bg1">
                <h3>activity senior</h3><button>Read More</button>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 p-0">
              <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/junior-activity.png" className="img-fluid" alt="Mata Mariyam Jan Sewa" />
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 p-0">
              <div className="insights-content bg1">
                <h3>activity junior</h3><button>Read More</button>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 p-0">
              <div className="insights-content bg2">
                <h3>sports senior</h3><button>Read More</button>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 p-0">
              <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/sports-senior.png" className="img-fluid" alt="Mata Mariyam Jan Sewa" />
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 p-0">
              <div className="insights-content bg2">
                <h3>sports Junior</h3><button>Read More</button>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 p-0">
              <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/sports-junior.png" className="img-fluid" alt="Mata Mariyam Jan Sewa" />
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 p-0">
              <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/media.png" className="img-fluid" alt="Mata Mariyam Jan Sewa" />
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 p-0">
              <div className="insights-content bg3">
                <h3>Media</h3><button>Read More</button>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 p-0">
              <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/honour.png" className="img-fluid" alt="Mata Mariyam Jan Sewa" />
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 p-0">
              <div className="insights-content bg3">
                <h3>Special honour</h3><button>Read More</button>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 p-0">
              <div className="insights-content bg4">
                <h3>Alumni</h3><button>Read More</button>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 p-0">
              <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/alumni.png" className="img-fluid" alt="Mata Mariyam Jan Sewa" />
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 p-0">
              <div className="insights-content bg4">
                <h3>Memories</h3><button>Read More</button>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12 p-0">
              <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/memories.png" className="img-fluid" alt="Mata Mariyam Jan Sewa" />
            </div>
          </div>
        </div>
      </div>
      <div className='calender'>
        <div className='container'>
          <div className='container-fluid'>
            <div className='row'>
              <div className='col-xl-5 col-lg-5 col-md-12'>
                <div className='title'>
                  <p>important days and Dates</p>
                  <h2>academic calendar</h2>
                </div>
                <Calender />
              </div>

              <div className='col-xl-7 col-lg-7 col-md-12'>
                <div className='title'>
                  <p>Event Section</p>
                  <h2>Important Events</h2>
                </div>
                <Events />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="topper_bg padded-sec">
        <div className="container-fluid section-title">
          <div className="row">
            <div className='col-md-12'>
              <div className='topper-title'>
                <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/topper.png" className='img-fluid m-auto d-block ' /></LazyLoad>
              </div>
            </div>
            <div className="col-lg-6">
              <div className='d-flex '>
                <div className='topper-block'>
                  <h3 className='text-center'> X<sup>th</sup> Topper</h3>
                  <TopperX />
                </div>
                {/* <div className="arrow-button"><a href="/"><i className="bi bi-arrow-right"></i></a></div> */}
              </div>
            </div>

            <div className="col-lg-6">
              <div className='d-flex '>
                <div className='topper-block'>
                  <h3 className='text-center'>XII<sup>th</sup> Topper</h3>
                  <TopperXII />
                </div>
                {/* <div className="arrow-button"><a href="/"><i className="bi bi-arrow-right"></i></a></div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="homegallery">
        <div className="container">
          <div className="row">
            <div className='col-md-8 col-sm-12 section-title'>
              <div className='title p-0'>
                <p>gallery section</p>
                <h2>Activities in images</h2>
              </div>
              <Gallery />
            </div>
            <div className="col-md-4  col-sm-12">
              <div className="video_gallery galleryimg">
                <div className='title'>
                  <p>Video section</p>
                  <h2>Activities in Video</h2>
                </div>
                <div className="galleryimgbox">
                  <LazyLoad> <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/video.png"
                    className="img-fluid"
                    alt="Mata Mariyam Jan Sewa"
                  /></LazyLoad>
                  <div className="gallerydesc">
                    <Link to="/VideoGallery" className="gallery_button">
                      <i className="bi bi-youtube"></i>
                    </Link>
                    <h6>Video Title</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Home